const markFirstDisruptionLeg = (tsiLegs) => {
  const ndxFirstLegWithDisruptions = tsiLegs.findIndex((leg) => {
    var _a, _b;
    return ((_b = (_a = leg.disruptions) == null ? void 0 : _a.length) != null ? _b : 0) > 0;
  });
  if (ndxFirstLegWithDisruptions === -1)
    return { ndxFirstLegWithDisruptions, legsWithMarkedFirstDisruptionLeg: tsiLegs };
  const legsWithMarkedFirstDisruptionLeg = [
    ...tsiLegs.slice(0, ndxFirstLegWithDisruptions),
    { ...tsiLegs[ndxFirstLegWithDisruptions], firstDisruption: true },
    ...tsiLegs.slice(ndxFirstLegWithDisruptions + 1)
  ];
  return { ndxFirstLegWithDisruptions, legsWithMarkedFirstDisruptionLeg };
};
var markFirstDisruptionLeg_default = markFirstDisruptionLeg;
export {
  markFirstDisruptionLeg_default as default
};
